module.exports = __webpack_public_path__ + "img/adobe-acrobat.59549612.svg";